import 'v-tooltip/dist/v-tooltip.css';
import './v-tooltip.scss';

export { default as VTooltip } from 'v-tooltip';

export const config = {
	offset: [0, 0],
};
